import StampColelction from "th/stampCollection";

export { StampColelction };

customElements.define(
  "th-stamp-collection",
  StampColelction.CustomElementConstructor
);
